import React, { useState, useEffect } from "react";
import useAuth from '../hooks/useAuth';
import { useT } from "contexts/TranslationContext";
import { Button } from "@mui/material";
const PRIMARY_GREEN = '#4CAF50';

const Subscription = ({ paymentAmount }) => {
  const { getToken } = useAuth();
  const t = useT();

  const [paymentLink, setPaymentLink] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [paymentMethods, setPaymentMethods] = useState([]);

  const PAYMENT_AMOUNT = paymentAmount;
  // const PAYMENT_AMOUNT = 0; // EUR/month

  const handlePayment = async () => {
    
    setError("");
    setLoading(true);

    try {
      // Call your Node.js backend endpoint to initiate MIT
      const url = `${process.env.REACT_APP_URL}/api/payment/oneoff`;
      const token = await getToken();

      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${token}`);
      
      const body = {
        amount: PAYMENT_AMOUNT,
        tokenAgreement: "unscheduled", // or "recurring" based on your needs
        // tokenAgreement: "recurring",
      };
      const response = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      });
      
      // Parse the JSON body
      const data = await response.json();

      console.log("Payment initiation response:", data);
      // The backend should return the payment link or payment_reference
      // setPaymentLink(response.data.payment_link || response.data.payment_reference);
      const methods = await filterPaymentMethods(data.payment_methods);
      setPaymentMethods(methods);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setError("Payment initiation failed. Try again.");
      setLoading(false);
    }
  };

  const filterPaymentMethods = async (paymentMethods) => {
    console.log("All payment methods:", paymentMethods);
    const estonianBanks = paymentMethods.filter(
      (method) => method.country_code === "EE" && method.available
    );

    return estonianBanks;
  };


  return (
    <div style={{ maxWidth: 400, margin: "50px auto", fontFamily: "sans-serif" }}>

      <div style={{ marginTop: 20 }}>
        { paymentMethods && paymentMethods.length > 0 && (
          <>
            <p>{t("payment.select")}</p>
            {paymentMethods.map((method) => (
              <a
                key={method.source}
                href={method.payment_link}
                className="flex items-center gap-3 p-4 rounded-xl border hover:shadow-lg transition"
              >
              <img src={method.logo_url} alt={method.display_name} className="h-8" />
              {/* <span className="text-base font-medium">{method.display_name}</span> */}
            </a>
            ))}
          </>
        )}
      </div>

      {error && <p style={{ color: "red" }}>{error}</p>}
      
      { !paymentMethods || paymentMethods.length === 0 && (
        <Button
                    variant="contained"
                    size="large"
                    sx={{
                        bgcolor: PRIMARY_GREEN,
                        '&:hover': {
                            bgcolor: '#2d845e', // Darker green on hover
                            transform: 'scale(1.02)',
                            boxShadow: 4,
                        },
                        px: 4,
                        py: 1.5,
                        width: '175px',
                        borderRadius: '8px',
                        fontWeight: 600,
                        textTransform: 'none',
                        boxShadow: 3,
                        transition: 'all 300ms ease',
                    }}
                    aria-label="Get started today"
                    onClick={handlePayment}
                >
              {t("payment.pay")}
            </Button>
      )}

      {paymentLink && (
        <div style={{ marginTop: 20 }}>
          <p>Payment initiated!</p>
          <a
            href={paymentLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "underline" }}
          >
            Complete Payment
          </a>
        </div>
      )}
    </div>
  );
};

export default Subscription;
